module.exports = __webpack_public_path__ + "static/media/contasareceber.25523f23.png";